import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export default class NextIcon extends PureComponent {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="20" viewBox="0 0 14 20">
        <title>Next</title>
        <path fillRule="nonzero"
          fill={this.props.active ? '#ffffff' : '#0092ff'}
          d="M4 20l-4-4 6-6-6-6 4-4 10 10z" />
      </svg>
    );
  }
}

NextIcon.propTypes = {
  active: PropTypes.bool
};
